module.exports = __webpack_public_path__ + "static/media/jpy.91f2439d.svg";